<!-- div class="container header px-24">
    <div class="p-8">AdClarity</div>

    <div class="divider"></div>
</div -->

<router-outlet></router-outlet>

<div class="container px-40">
    <div class="divider"></div>

    <div class="footer py-16">
        <div></div>

        <button
            *ngIf="showFullReportBtn"
            mat-button
            type="button"
            color="accent"
            class="u-button h-32 font-12"
            (click)="onViewReportBtnClick()"
        >
            View full report
        </button>
    </div>
</div>

<adblock-check></adblock-check>
